module.exports = __webpack_public_path__ + "static/media/teclados.5f149112.png";